import { useQuery } from "@tanstack/react-query";
import { Navigate, useParams } from "react-router";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { useTranslation } from "@coworker/locales";
import { PositionedLoaderIcon } from "@coworker/reusable/Loader";
import { fetchAPI } from "../../../hooks/API/testbuy.service";
import { TestBuyDetailPage } from "./TestBuyDetailPage";

type TestbuyVersionResponse = {
  version: "v1" | "v2";
};

async function getTestbuyVersion(id: string) {
  return fetchAPI(
    `testbuy/${id}/version`,
    "GET"
  ) as Promise<TestbuyVersionResponse>;
}

export function TestbuyDirectLink() {
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation();
  const { data, isError, refetch } = useQuery({
    queryKey: ["get-testbuy-version", id],
    queryFn: () => getTestbuyVersion(id!),
    enabled: !!id,
    retry: false,
  });

  if (isError) {
    return (
      <div
        style={{
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          height: "100vh",
          justifyContent: "center",
        }}
      >
        <FixaText tagName="p">{t("errorBoundaryString")}</FixaText>
        <FixaButton type="primary" onClick={() => refetch()}>
          {t("tryAgainString")}
        </FixaButton>
      </div>
    );
  }

  if (!data) {
    return <PositionedLoaderIcon />;
  }

  if (data.version === "v2") {
    return (
      <Navigate to={`/testbuy?testbuyId=${encodeURIComponent(id!)}`} replace />
    );
  }

  return <TestBuyDetailPage />;
}
